export const resetPasswordQuery = `
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      code
    }
  }
`;
